import { Injectable } from '@angular/core';

@Injectable()
export abstract class RouterService {
  abstract navigate;
  abstract back;

  abstract navigateToExternalUrl(value: string): void;
}
